/* On-demand carousel pictures. The first slide remains ordinary HTML; later
   pictures stay inert until requested. No scroll listener or image library. */
(() => {
  'use strict';
  if (window.MRLandingMedia) return;
  const jobs = new WeakMap();
  function ready(slide) {
    const image = slide?.querySelector('img');
    return !slide?.querySelector('template[data-mr-slide-picture]') &&
      (!image || (image.complete && image.naturalWidth > 0));
  }
  function ensure(slide, priority = 'low') {
    if (!slide) return Promise.resolve(false);
    if (jobs.has(slide)) return jobs.get(slide);
    const template = slide.querySelector('template[data-mr-slide-picture]');
    if (template) {
      const content = template.content.cloneNode(true);
      content.querySelectorAll('img').forEach(image => {
        image.loading = 'eager'; image.fetchPriority = priority;
      });
      template.replaceWith(content);
    }
    const image = slide.querySelector('img');
    if (!image) return Promise.resolve(true);
    const job = new Promise(resolve => {
      let finished = false;
      const finish = success => {
        if (finished) return;
        finished = true; clearTimeout(timeout);
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
        resolve(success);
      };
      const loaded = () => {
        if (typeof image.decode === 'function') image.decode().then(() => finish(true), () => finish(image.naturalWidth > 0));
        else finish(image.naturalWidth > 0);
      };
      const failed = () => finish(false);
      const timeout = setTimeout(failed, 20000);
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', failed, { once: true });
      if (image.complete) image.naturalWidth > 0 ? loaded() : failed();
    });
    jobs.set(slide, job);
    job.then(success => { if (!success) jobs.delete(slide); });
    return job;
  }
  window.MRLandingMedia = { ready, ensure };
})();
